"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _createSvg = require("../createSvg");

var _interfaces = require("../interfaces");

var _default = (0, _createSvg.createSvg)('IconDownload', new _interfaces.SVGIconWithSizes((0, _defineProperty2.default)({}, _interfaces.IconSize.Small, {
  paths: ['M16,16 C16.553,16 17,16.447 17,17 L17,19 C17,19.553 16.553,20 16,20 L4,20 C3.447,20 3,19.553 3,19 L3,17 C3,16.447 3.447,16 4,16 C4.553,16 5,16.447 5,17 L5,18 L15,18 L15,17 C15,16.447 15.447,16 16,16 Z M9.292,14.7061 L5.293,10.7071 C4.902,10.3161 4.902,9.6841 5.293,9.2931 C5.684,8.9021 6.316,8.9021 6.707,9.2931 L9,11.5861 L9,1.0001 C9,0.4471 9.447,0.0001 10,0.0001 C10.553,0.0001 11,0.4471 11,1.0001 L11,11.5861 L13.293,9.2931 C13.684,8.9021 14.316,8.9021 14.707,9.2931 C15.098,9.6841 15.098,10.3161 14.707,10.7071 L10.708,14.7061 C10.616,14.7991 10.505,14.8721 10.382,14.9231 C10.26,14.9741 10.13,15.0001 10,15.0001 C9.87,15.0001 9.74,14.9741 9.618,14.9231 C9.495,14.8721 9.384,14.7991 9.292,14.7061 Z'],
  params: {
    width: '20',
    height: '20'
  },
  height: 20,
  width: 20
})));

exports.default = _default;